import React, { Component } from 'react'
import {
  MDBBtn,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../../components/content/MDB4Datatable/MDB4Datatable.component'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import WebsiteBlogPostService from '../../shared/services/WebsiteBlogPost.service'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import moment from 'moment'

class BlogPostsList extends Component {
  state = {
    confirmModal: false,
    viewdata: '',
    postList: [],
    loading: false,
    deleting: false,
    data: {
      columns: [
        { label: 'Title', field: 'title', sort: 'asc', width: 250 },
        { label: 'Slug', field: 'slug', sort: 'asc', width: 200 },
        { label: 'Category', field: 'category', sort: 'asc', width: 120 },
        { label: 'Status', field: 'status', sort: 'asc', width: 100 },
        { label: 'Published', field: 'published_at', sort: 'asc', width: 120 },
        { label: 'Updated', field: 'updated_at', sort: 'asc', width: 120 },
        { label: 'Actions', field: 'actions', sort: 'disabled', width: 120 },
      ],
      rows: [],
    },
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    this.setState({ loading: true })
    try {
      const result = await WebsiteBlogPostService.search()
      this.setState({ postList: result?.models || [] }, this.setRows)
    } catch (error) {
      toast.error('Failed to load blog posts.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      this.setState({ loading: false })
    }
  }

  setRows = () => {
    const { postList } = this.state
    if (!postList.length) return

    const rows = postList.map(row => {
      const self = this

      function edit() {
        self.props.history.push(`/admin-blog-posts/${row.id}/edit`)
      }

      function deleteRow() {
        self.confirmToggle({ viewdata: row })
      }

      const formatDate = date => (
        <span searchvalue={date ? moment(date).format('YYYY/MM/DD') : ''}>
          {date ? moment(date).format('MM/DD/YYYY') : 'N/A'}
        </span>
      )

      const statusBadge = (
        <span
          className={`badge badge-${
            row.status === 'published' ? 'success' : row.status === 'draft' ? 'warning' : 'secondary'
          }`}
        >
          {row.status}
        </span>
      )

      const actions = (
        <div className='d-flex align-items-center justify-content-center'>
          <div className='cursor-pointer d-inline-block mr-3' role='button' onClick={edit}>
            <i className='fa fa-edit fa-2x blue-text p-1'></i>
          </div>
          <div className='cursor-pointer d-inline-block' role='button' onClick={deleteRow}>
            <i className='fa fa-trash fa-2x red-text p-1'></i>
          </div>
        </div>
      )

      return {
        title: row.title || '',
        slug: row.slug || '',
        category: row.category || '',
        status: statusBadge,
        published_at: formatDate(row.published_at),
        updated_at: formatDate(row.updated_at),
        actions,
      }
    })

    this.setState({ data: { ...this.state.data, rows } })
  }

  confirmToggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  deletePost = async id => {
    this.setState({ deleting: true })
    try {
      await WebsiteBlogPostService.delete(id)
      this.confirmToggle()
      toast.success('Blog post deleted successfully.', {
        position: toast.POSITION.TOP_RIGHT,
      })
      this.fetchData()
    } catch (error) {
      this.confirmToggle()
      toast.error('Failed to delete blog post.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      this.setState({ deleting: false })
    }
  }

  render() {
    const { confirmModal, data, loading } = this.state

    const createNew = () => {
      this.props.history.push('/admin-blog-posts/create')
    }

    return (
      <DashboardLayout>
        <main className='mainSection'>
          <MDBContainer fluid className='mt-5'>
            <h2>
              Blog Posts
              <div className='d-inline-block'>
                <MDBBtn type='button' color='default' tag='a' floating gradient='blue' onClick={createNew}>
                  <MDBIcon icon='plus' />
                </MDBBtn>
              </div>
            </h2>
            {loading ? (
              <h4 className='p4'>Loading...</h4>
            ) : (
              <MDB4Datatable
                data={data}
                sortRows={['title', 'slug', 'category', 'published_at', 'updated_at']}
                striped
                bordered
                small
                order={['updated_at', 'desc']}
                entriesOptions={[25, 50, 100]}
                entries={25}
              />
            )}

            <MDBModal open={confirmModal} onClose={this.confirmToggle}>
              <MDBModalDialog size='sm'>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Delete Blog Post</MDBModalTitle>
                    <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirmToggle}></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <div className='h5'>
                      Are you sure you want to delete &quot;
                      {this.state.viewdata?.title}&quot;?
                    </div>
                    <MDBBtn type='button' color='secondary' size='sm' onClick={this.confirmToggle}>
                      Close
                    </MDBBtn>
                    <MDBBtn
                      type='button'
                      color='danger'
                      size='sm'
                      onClick={() => this.deletePost(this.state.viewdata.id)}
                    >
                      {this.state.deleting ? 'Deleting...' : 'Delete'}
                    </MDBBtn>
                  </MDBModalBody>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default withRouter(BlogPostsList)
